import _objectSpread from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/home/jenkins/workspace/tServices_Forms_Client_CICD_main/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["size", "variant", "icon"];
import { jsx } from 'react/jsx-runtime';
import { Button } from '@ariakit/react';
import clsx from 'clsx';
import { forwardRef, createElement } from 'react';
import styles from './icon-button.module.js';
import { iconSizeMap } from './utils.js';
var IconButton = /*#__PURE__*/forwardRef(function (props, forwardedRef) {
  var _props$size = props.size,
      size = _props$size === void 0 ? 'small' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'default' : _props$variant,
      icon = props.icon,
      rest = _objectWithoutProperties(props, _excluded);

  var sizeStyles = variant === 'small-utility' ? styles.small : styles[size];
  return jsx(Button, _objectSpread(_objectSpread({}, rest), {}, {
    ref: forwardedRef,
    className: clsx(styles.iconButton, styles[variant], sizeStyles, props.className),
    children: /*#__PURE__*/createElement(icon, {
      className: styles.icon,
      height: iconSizeMap[size],
      width: iconSizeMap[size],
      role: 'presentation'
    })
  }));
});
IconButton.displayName = 'IconButton';
export { IconButton };